<template>
  <div style="position: fixed; top:0; left:0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.7); z-index: 2;" v-on:click="closeForm">
    <div style="position: absolute; top: 50%; left: 50%; width: 500px; max-width: 90%; height: 90%; transform: translate(-50%, -50%); background-color: white; border-radius: 20px;" v-on:click.stop="dummy">

      <div style="width: 100%; height: 50px; line-height: 50px; text-align: center; font-weight: bold; font-size: 30px;">
        이사 문의 신청
      </div>
      <div style="width: 100%; height: calc(100% - 124px); overflow-y: auto">
        <v-container style="padding-top:20px; padding-bottom: 20px;">
          <v-row>
            <v-col cols="12">신청자 이름 (*필수)</v-col>
            <v-col cols="12">
              <input class="form-control" type="text" v-model="item.requester"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">전화번호 (*필수)</v-col>
            <v-col cols="12">
              <input class="form-control" type="text" v-model="item.phoneNumber"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">회사명 (기업고객 또는 주재상사원)</v-col>
            <v-col cols="12">
              <input class="form-control" type="text" v-model="item.companyName"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">이메일</v-col>
            <v-col cols="12">
              <input class="form-control" type="text" v-model="item.email"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12 no-vertical-padding">이사 종류 / 운송방식 (*필수)</v-col>
            <v-col cols="12">
              <select class="form-control" v-model="item.shippingMode" @change="onRequestTypeChanged">
                <option value="">선택하세요</option>
                <option value="SEA OUT">귀국 이사 - 해상</option>
                <option value="AIR OUT">귀국 이사 - 항공</option>
                <option value="EUROLAND">3국 이사 (유럽간 트럭운송)</option>
                <option value="DOMESTIC">영국내 이사</option>

              </select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12 no-vertical-padding">방문 요청일 (*필수)
              <br>
              <span style="color:#FF5733;">예약시점에서 최소 3일 이후이후 가능합니다. 런던 근교의 경우 방문 날짜는 일주일전 신청 바랍니다. 지방의 경우는 전화로 사전 문의 바랍니다.</span>
              <br><a href="tel:07837203341">+44 7837 203 341</a>
            </v-col>
            <v-col cols="8">
              <input class="form-control" type="date" v-model="item.visitDate" @change="visitDateSelected"/>
            </v-col>
            <v-col cols="4">
              <select class="form-control" v-model="item.visitHour">
                <option value="0">시간선택</option>
                <option value="10">10시</option>
                <option value="11">11시</option>
                <option value="12">12시</option>
                <option value="13">13시</option>
                <option value="14">14시</option>
                <option value="15">15시</option>
                <option value="16">16시</option>
                <option value="17">17시</option>

              </select>
            </v-col>
          </v-row>

<!--          <v-row>-->
<!--            <v-col cols="12">해상 / 항공 선택</v-col>-->
<!--            <v-col cols="12">-->
<!--              <select class="form-control" v-model="item.shippingMode">-->
<!--                <option value="">선택하세요</option>-->
<!--                <option value="air">항공</option>-->
<!--                <option value="ocean">해상</option>-->
<!--                <option value="lorry">EURO LAND(유럽간 트럭운송)</option>-->
<!--              </select>-->
<!--            </v-col>-->
<!--          </v-row>-->


          <v-row>
            <v-col cols="12">동반 가족수</v-col>
            <v-col cols="12">
              <input class="form-control" type="number" v-model="item.headCount"/>
            </v-col>
          </v-row>




          <v-row>
            <v-col cols="12">영국내 주소 (*필수) (<span style="color:red;">POST CODE를 반드시 입력해주세요</span>)</v-col>
            <v-col cols="12">
              <input class="form-control" type="text" v-model="item.addressFrom"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">도착지 국가</v-col>
            <v-col cols="12">
              <input class="form-control" type="text" v-model="item.countryTo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">도착지 주소</v-col>
            <v-col cols="12">
              <input class="form-control" type="text" placeholder="미정인 경우 또는 지방의 경우 도시명만 기재" v-model="item.addressTo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">이사 예정일 (*필수)</v-col>
            <v-col cols="12">
              <input class="form-control" type="date" v-model="item.expectedMoveDate"/>
            </v-col>
          </v-row>


        </v-container>

      </div>
      <div style="width: 100%; height: 74px;">
        <v-container>
          <v-row>
            <v-col cols="6" class="text-left">
              <button class="btn btn-dark" v-on:click="closeForm">취소</button>
            </v-col>
            <v-col cols="6" class="text-right">
              <button class="btn btn-primary" v-on:click="submitForm">접수하기</button>
            </v-col>
          </v-row>
        </v-container>
      </div>

    </div>
  </div>
</template>

<script>
    import EventBus from "../api/event-bus";
    import {submitRequest} from "../api/request";
    import {millisToDate, showDialog} from "../api/utils";

    export default {
        name: "VisitRequestForm",
        props: {
            item: {
                type:Object,
                default: function(){return {}}
            },
            onClose: {
              type:Function,
              default: null,
            }
        },
        components: {},
        data() {
            return {
              name:'',
              nameErrors:'Incorrect'

            }
        },
        methods: {
          dummy: function() {

          },
          visitDateSelected: function() {
            if(this.item.visitDate === null) {
              return;
            }

            let today = new Date();
            today.setDate(today.getDate() + 4);
            let earliestDate = millisToDate(today.getTime());

            if(earliestDate > this.item.visitDate) {
              showDialog("가장 빠른 방문일은 " + earliestDate + "입니다. 다시 선택해주세요.");
              return;
            }

          },
          onRequestTypeChanged: function() {
            if(this.item.shippingMode === 'SEA OUT' || this.item.shippingMode === 'AIR OUT') {
              this.item.countryTo = '대한민국';
            } else if(this.item.shippingMode === 'DOMESTIC') {
              this.item.countryTo = '영국';
            } else {
              this.item.countryTo = "";
            }
          },
          closeForm: function() {
            if(this.onClose != null) {
              this.onClose();
            }
          },
          submitForm: function() {
            console.log("Now verify");
            console.log(this.item);
            if(this.item.phoneNumber === '' || this.item.phoneNumber.length < 11) {
              window.alert("전화번호를 입력해주세요");
              return;
            }
            if(this.item.requestType === '') {
              window.alert("이사종류를 선택하세요");
              return;
            }

            if(this.item.visitDate === null || this.item.visitDate.length === 0) {
              window.alert("원하시는 방문 날짜를 선택해주세요");
              return;
            }
            if(this.item.expectedMoveDate === null || this.item.expectedMoveDate.length === 0) {
              window.alert("이사 예정일을 선택해주세요");
              return;
            }
            if(this.item.visitHour === 0) {
              window.alert("원하시는 방문 시간을 선택하세요");
              return;
            }
            if(this.item.shippingMode === '') {
              window.alert("shipping mode를 선택하세요");
              return;
            }
            if(this.item.requester === null || this.item.requester === '') {
              window.alert("이름을 선택하세요");
              return;
            }
            //
            // if(this.item.email === '' || this.item.email.length < 5) {
            //   window.alert("이메일을 입력해주세요");
            //   return;
            // }
            if(this.item.addressFrom === '' || this.item.addressFrom.length < 5) {
              window.alert("주소를 입력해주세요");
              return;
            }
            // if(this.item.addressTo === '' || this.item.addressTo.length < 2) {
            //   window.alert("도착지 주소를 입력해주세요");
            //   return;
            // }
            // if(this.item.countryTo === '' || this.item.countryTo.length < 2) {
            //   window.alert("도착국가를 입력해주세요");
            //   return;
            // }
            // if(this.item.expectedMoveDate == null || this.item.expectedMoveDate === '0000:00:00') {
            //   window.alert("예정 이주 날짜를 선택하세요");
            //   return;
            // }
            console.log("Verified form");
            console.log(this.item)
            let self = this;
            submitRequest(this.item)
            .then(function(data){
              if(data.success == true) {
                EventBus.$emit('onSubmitted', data.item);

              } else {
                window.alert("요청이 이루어지지 않았습니다. " + data.message);
              }
            })
            .catch(function(err) {
              console.log(err);
              if(err.response != undefined) {
                console.log(err.response);
              }
            })
          }
        }
    }
</script>

<style scoped>
  label.form-control {
    border:none;
  }
  .no-vertical-padding {
    padding-top: 0px;
    padding-bottom: 0px;
    text-align: left;
  }
  .row > * {
    padding-top:0px;
    padding-bottom: 0px;
    text-align: left;
  }
  .row {
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/form/VisitRequestForm.vue